export const TIME_OPTIONS = {
    AMPM: ["AM", "PM"],
    HOUR: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    MINUTE: [
        "00",
        "05",
        "10",
        "15",
        "20",
        "25",
        "30",
        "35",
        "40",
        "45",
        "50",
        "55",
    ],
    MINUTE_FULL: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
    ]
}

export const CUSTOMIZE_PRICE_INFO_TEXT_OPTIONS = [
    {
        label: "Booking Rate",
        key: "BOOKING_RATE",
        model: "customize_booking_rate_text",
    },
    {
        label: "Booking Fee",
        key: "BOOKING_FEE",
        model: "customize_booking_fee_text",
    },
    {
        label: "Per Booking Fee",
        key: "PER_BOOKING_FEE",
        model: "customize_per_booking_fee_text",
    },
    {
        label: "Client Rate",
        key: "CLIENT_RATE",
        model: "customize_client_rate_text",
    },
    {
        label: "Candidate Rate",
        key: "CANDIDATE_RATE",
        model: "customize_candidate_rate_text",
    },
    {
        label: "Agency Fee",
        key: "AGENCY_FEE",
        model: "customize_agency_fee_text",
    },
    {
        label: "Travel Fee",
        key: "TRAVEL_FEE",
        model: "customize_travel_fee_text",
    },
    {
        label: "Rush Fee",
        key: "RUSH_FEE",
        model: "customize_rush_fee_text",
    },
    {
        label: "Candidate Rush Fee",
        key: "CANDIDATE_RUSH_FEE",
        model: "customize_candidate_rush_fee_text",
    },
    {
        label: "Per Booking Agency Fee",
        key: "PER_BOOKING_AGENCY_FEE",
        model: "customize_per_booking_agency_fee_text",
    },
    {
        label: "Per Booking Candidate Fee",
        key: "PER_BOOKING_CANDIDATE_FEE",
        model: "customize_per_booking_candidate_fee_text",
    },
    {
        label: "Admin Fee",
        key: "ADMIN_FEE",
        model: "customize_admin_fee_text",
    },
    {
        label: "Admin Percentage Fee",
        key: "ADMIN_PERCENTAGE",
        model: "customize_admin_percentage_text",
    },
    {
        label: "Additional Fees",
        key: "BOOKING_RATE",
        model: "customize_additional_fee_text",
    },
]

export const AGENCY_TYPES = {
    NANNY_AND_HOUSE_HOLDING_STAFF: "Nanny and Household Staffing",
    DENTAL: "Dental",
    VIRTUAL_ASSISTANT: "Virtual Assistant",
    OTHER: "Other"
}

export const SCRAPER_TYPES = [
    {
        label: "Bright",
        value: "Bright",
    },
    {
        label: "Care",
        value: "Care",
    },
]

export const AGENCY_SERVICES = [
    "Long Term Nanny Placement",
    "Short Term Nanny Placement",
    "On Call Sitters",
    "Newborn Care Specialists",
    "Doulas",
    "Corporate Back-up Care",
    "Event Childcare",
    "Hotel Childcare",
    "Preschools",
    "Daycare Centers",
    "Home Staffing Specialists",
    "Domestic Worker Placement",
    "Nanny Placement",
    "Executive Nanny Placement",
    "Au Pair Placement",
    "Caregiver Placement",
    "Night Nurse Placement",
    "Office Cleaner Placement",
    "Temp Placement"
]

export const DISTANCE_UNITS = [
    {
        label: "Kilometer",
        value: "km"
    },
    {
        label: "Mile",
        value: "miles"
    }
]




// WEBPACK FOOTER //
// ./src/constants/options.js